<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>离托学生({{studentList.length}})</h1>
      </div>
      <div class="liner"></div>
    </div>


    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page">
      <ul class="list-group-item primary">
        <li class="list-group" v-for="student in studentList">
          <router-link class="group-link clearfix" :to="{path:'/student/detail/' + student.studentId}">
            <span class="img-wrap small pull-left"><img :data-original="student.imageAddress ? (student.baseAcessPath + student.imageAddress) : img_default" width="40" height="40"/></span>
            <span class="group-txt">
              <span class="block overhide">
                <cite class="font-16 pull-left">{{student.studentName}}</cite><i v-bind:class="student.sex == '男' ? 'img-sex boy' : 'img-sex girl'" >{{student.sex}}</i>
              </span>
            </span>
          </router-link>
          <div class="liner"></div>
        </li>
      </ul>
    </div>
    </mt-loadmore>
  </div>
</template>

<script>
import { service } from '../../service'
export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      filterClassSfzt: '离托',
      studentList: {}
    }
  },
  mounted: function () {
    this.get_new_student_list_para.curcheId = this.cookie_login_data.curcheId
    this.get_new_student_list_para.sfzt = this.filterClassSfzt
    this.getStuList()
  },
  methods: {
    loadTop (id) {
      this.getStuList()
      this.$refs.loadmore.onTopLoaded(id)
    },
    getStuList: function () {
      let that = this
      let obj = {context: this, para: this.get_new_student_list_para, successFun: (response) => {
        that.studentList = response.data
      }}
      service.request(obj)
    }
  }
}
</script>


// WEBPACK FOOTER //
// StudentOut.vue?615587d4